import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import {
  type APIResponse,
  type PermissionGrant,
  type PermissionCatalogDefinition,
  type PermissionGroup,
  type PermissionGroupWithUsers,
} from "@/lib/types";

/** Mirrors PermissionGroupCreateBody from the FastAPI V2 contract. */
export type CreatePermissionGroupData = {
  label: string;
  description?: string | null;
  grants?: PermissionGrant[];
};

/** Mirrors PermissionGroupUpdateBody from the FastAPI V2 contract. */
export type UpdatePermissionGroupData = {
  id: string;
  dateModified: string;
  label?: string;
  description?: string | null;
  grants?: PermissionGrant[];
};

export const getPermissionGroups = () =>
  authenticatedFastApiAxiosInstance
    .get<APIResponse<PermissionGroupWithUsers[]>>("firms/v2/permission-groups")
    .then((res) => res.data);

export const getPermissionCatalog = () =>
  authenticatedFastApiAxiosInstance
    .get<
      APIResponse<PermissionCatalogDefinition[]>
    >("firms/v2/permission-catalog")
    .then((res) => res.data);

export const createPermissionGroup = (data: CreatePermissionGroupData) =>
  authenticatedFastApiAxiosInstance
    .post<APIResponse<PermissionGroup>>("firms/v2/permission-groups", data)
    .then((res) => res.data);

export const updatePermissionGroup = (data: UpdatePermissionGroupData) =>
  authenticatedFastApiAxiosInstance
    .patch<APIResponse<PermissionGroup>>("firms/v2/permission-groups", data)
    .then((res) => res.data);

export const deletePermissionGroup = (id: string) =>
  authenticatedFastApiAxiosInstance
    .delete<APIResponse<PermissionGroup>>(`firms/v2/permission-groups/${id}`)
    .then((res) => res.data);
